// extracted by mini-css-extract-plugin
module.exports = {"section10":"Section10_section10__iBQMn"};